import { Button, Stack, styled } from "@mui/material";

export const GameModeContainer = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(4),
  display: "flex",
  boxSizing: "border-box",
  width: "100%",
}));

export const GameModeCard = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  justifyContent: "space-between",
  backdropFilter: `blur(${theme.spacing(1.25)})`,
  backgroundColor: `${theme.palette.dsSurface.v100}80`,
  borderRadius: theme.spacing(2),
  border: `1px solid ${theme.palette.dsSurface.v400}80`,
  textAlign: "center",
  padding: theme.spacing(3),
}));

export const GameModeOptionButton = styled(Button)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: `${theme.palette.dsSurface.v300}80`,
  border: `${theme.spacing(0.25)} solid ${theme.palette.dsSurface.v400}80`,
  padding: theme.spacing(1.5, 2.5),
  cursor: "pointer",
  flex: 1,
  transition: "all 0.3s ease-in-out",
  color: theme.palette.dsBase.v200,
  "&:hover": {
    backgroundColor: `${theme.palette.dsSurface.v400}80`,
    border: `${theme.spacing(0.25)} solid ${theme.palette.dsSurface.v500}80`,
  },
}));
